import { grScope } from "@gr-common/head/logger";

const log = grScope.scope("core.promise");

type ExecutorParameters<R> = Parameters<ConstructorParameters<typeof Promise<R>>[0]>;

const promise = <R>(fn: (...args: ExecutorParameters<R>) => unknown): Promise<R> =>
  new Promise<R>((...args) => {
    fn(...args);
  });

const tryRun = async <A extends unknown[], R>(
  fn: (...args: A) => R,
  resolvers: ExecutorParameters<R>,
  fnArgs: A,
  options: RunWithOptionsBase,
): Promise<void> => {
  try {
    if (options.signal?.aborted) {
      throw options.signal.reason;
    }

    resolvers[0](await fn(...fnArgs));
  } catch (e) {
    if (options.silent) {
      log.info("callback failed with", e);
      resolvers[0](undefined as never);
    }

    if (options.nofail) {
      resolvers[0](e as never);
    }

    resolvers[1](e);
  }
};

export interface RunWithOptionsBase {
  /**
 *
 */
  signal?: AbortSignal;

  /**
 *
 *
 *
 *
 */
  silent?: boolean;

  /**
 *
 *
 *
 *
 */
  nofail?: boolean;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithMicrotask = <A extends unknown[], R>(
  fn: (...args: A) => R,
  options: RunWithOptionsBase = {},
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) =>
    queueMicrotask(() => tryRun(fn as never, resolvers, fnArgs, options)),
  );

/**
 *
 */
export interface WithMacrotaskOptions extends RunWithOptionsBase {
  /**
 *
 */
  timeout?: number;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithMacrotask = <A extends unknown[], R>(
  fn: (...args: A) => R,
  options: WithMacrotaskOptions = {},
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) => {
    setTimeout(() => tryRun(fn as never, resolvers, fnArgs, options), options.timeout);
  });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithAnimationFrame = <A extends unknown[], R>(
  fn: (this: Parameters<FrameRequestCallback>[0], ...args: A) => R,
  options: RunWithOptionsBase = {},
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) => {
    requestAnimationFrame((time) => tryRun(fn.bind(time) as never, resolvers, fnArgs, options));
  });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const runWithRenderSlice = <A extends unknown[], R>(
  fn: (this: Parameters<FrameRequestCallback>[0], ...args: A) => R,
  options: WithMacrotaskOptions = {},
  ...fnArgs: A
): Promise<Awaited<R>> =>
  promise<Awaited<R>>((...resolvers) => {
    requestAnimationFrame((time) => {
      setTimeout(() => tryRun(fn.bind(time) as never, resolvers, fnArgs, options), options.timeout);
    });
  });
